module.exports = __webpack_public_path__ + "static/media/orange-bg.a985a399.svg";